jQuery(function($){
	if($('.standing-order-wrapper').length) {
		$('#visible-to-members input[type="checkbox"]').on('change', function(){
			console.log($(this).prop('checked'));

			var data = {
				action: 'choralorg_standing-order_update_visibility',
				event_id: $('#event_id').val(),
				value: $(this).prop('checked')
			};

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
			});			
		});

		function saveAllTableLayouts() {
			var allTables = [];
			$('.standing-order-wrapper:not(.to-copy) .standing-order-table-rows-wrapper .standing-order-table').each(function(){
				allTables.push(saveTableLayout($(this).attr('table')));
			});

			var data = {
				action: 'choralorg_standing-order_update_record',
				event_id: $('#event_id').val(),
				updated: Math.floor(Date.now() / 1000),
				value: btoa(JSON.stringify(allTables))
			};

			console.log(allTables);
			console.log(data);

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
			});
		}

		function saveAllPreviousTableLayouts() {
			var allTables = [];
			$('.standing-order-wrapper:not(.to-copy) .standing-order-table-rows-wrapper .standing-order-table').each(function(){
				allTables.push(saveTableLayout($(this).attr('table')));
			});

			var data = {
				action: 'choralorg_standing-order_update_previous_record',
				event_id: $('#event_id').val(),
				updated: Math.floor(Date.now() / 1000),
				value: btoa(JSON.stringify(allTables))
			};

			console.log(allTables);
			console.log(data);

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
			});
		}

		function saveTableLayout(layoutIndex) {
			var table = $('#standing-order-table-' + layoutIndex);

			var tableParent = table.closest('.standing-order-table-wrapper');
			console.log(table);
			console.log(tableParent);

			var tableKeys = ['table', 'left_shift', 'right_shift'];
			var tableObj = {'total_count': 0, 'total_spots': 0, 'rows': [], 'members_in_table': []};

			//Rows
			$('#standing-order-rows-' + layoutIndex).find('.standing-order-row').each(function(){
				console.log($(this));
				tableObj.rows.push(writeRowObj($(this)));
			});
			
			//Director Row
			if(table.hasClass('has-director')) {
				$('.standing-order-table-rows-wrapper .standing-order-row.director').each(function(){
					tableObj.rows.push(writeRowObj($(this)));
				});
			}

			//Table
			$.each(tableKeys, function(index, key){
				tableObj[key] = table.attr(key);
			});

			//Members in table
			$.each(tableObj.rows, function(rowindex, row){
				$.each(row.spots, function(spotIndex, spot){
					tableObj.total_spots++;
					if(spot.length) {
						tableObj.rows[rowindex].count++;
						tableObj.total_count++;
						tableObj.members_in_table.push(spot);
					}
				});
				table.find('.standing-order-row[row="' + row.row + '"]').attr('count', tableObj.rows[rowindex].count);
				tableParent.find('.standing-order-table.has-controls .standing-order-row[row="' + row.row + '"] .row-stats').find('.count-value .filled').each(function(){
					$(this).html(tableObj.rows[rowindex].count);
				});
			});

			table.attr('total_count', tableObj.total_count).attr('total_spots', tableObj.total_spots);
			$('#standing-order-total-count').html(tableObj.total_count);
			$('#standing-order-total-spots').html(tableObj.total_spots);

			console.log(tableObj);
			return tableObj;
		}

		function writeRowObj(row) {
			var rowKeys = ['row', 'shift'];
			var rowObj = {'count': 0, 'spots': []};

			$.each(rowKeys, function(index, key){
				rowObj[key] = row.attr(key)
			});
			row.find('.standing-order-spot').each(function(index){
				var spot = $(this);
				var value = '';
				if(spot.hasClass('full')) {
					spot.find('.co-tile').each(function(){
						value = $(this).attr('member_id');
					});
				}
				rowObj['spots'].push(value);
				$(this).attr('spot', index);
			});
			
			return rowObj;
		}


		let dragType;

		let activeDragItem = {};

		$('.standing-order-responses').on({
			dragstart: function(e) {
				dragType = 'tile';
				tileDragStart(e);
			},
			dragend: function(e) {
				$(e.target).removeClass('dragging');
			},
			mouseup: function(e) {
				console.log('move!');
				tileDragStart(e, true);
			}
		}, '.co-tile[draggable=true]');

		$('.standing-order-table-rows-wrapper').on({
			dragstart: function(e) {
				dragType = 'tile';
				console.log('dragging');
				tileDragStart(e);
			},
			dragend: function(e) {
				$(e.target).removeClass('dragging');
			},
			mouseup: function(e) {
				if(!Object.keys(activeDragItem).length) {
					console.log('clicked')
					tileDragStart(e, true);
				}
			}
		}, '.co-tile[draggable=true]');

		$('.standing-order-wrapper').on({
			dragstart: function(e) {
				dragType = 'spot';
				console.log('dragging spot');
				spotDragStart(e);
				// tileDragStart(e);
			},
			dragend: function(e) {
				// $(e.target).show();
				console.log('dropped');
			}
		}, '.standing-order-spot:not(.full)[draggable=true]');

		$('.standing-order-wrapper').on({
			mouseup: function(e) {
				if($(e.target).closest('.co-tile').length) {
					if(!$(e.target).closest('.standing-order-spot').hasClass('dragging-from')) {
						if(Object.keys(activeDragItem).length) {
							tileDrop($(e.target)); //Swap
							saveAllTableLayouts();
						} else {
							//Do nothing
						}
					}
				} else { //Empty
					if(Object.keys(activeDragItem).length) {
						console.log('dropped here!');
						tileDrop($(e.target));
						saveAllTableLayouts();
					} else {
						console.log('no length', activeDragItem)
					}
				}
			}
		}, '.standing-order-spot[draggable="true"]');

		$('#choralorg-wrapper').on({
			dragenter: function(e) {
				console.log(dragType);
				var standingOrderSpot = $(e.target).closest('.standing-order-spot');
				var sameSpot = false;
				$('.standing-order-spot.dropping-' + dragType).each(function(){
					if($(this).attr('spot') == standingOrderSpot.attr('spot') && $(this).closest('.standing-order-row').attr('row') == standingOrderSpot.closest('.standing-order-row').attr('row')) {
						sameSpot = true;
					}
				});

				if(!sameSpot) {
					$('.standing-order-spot.dropping-' + dragType).removeClass('dropping-' + dragType);
					standingOrderSpot.addClass('dropping-' + dragType);
				}

				e.stopPropagation();
			},
			dragover: function(e) {
				e.originalEvent.dataTransfer.dropEffect = 'copy';
				return false;
			},
			drop: function(e) {
				$('.standing-order-spot').removeClass('dropping-' + dragType);
				e.stopPropagation();

				var type = activeDragItem.type;
				console.log(type);
				console.log(e.target);
				
				if(type !== 'tile') { //Spot
					console.log('nothing');
					var div = e.originalEvent.dataTransfer.getData('div');
					var row = e.originalEvent.dataTransfer.getData('row');
					var spot = e.originalEvent.dataTransfer.getData('spot');
					if($(e.target).closest('.standing-order-spot').length) {
						var previousRow = $('.standing-order-wrapper').find('.standing-order-row[row="' + row + '"]')
						var previousSpot = previousRow.find('.standing-order-spot[spot="' + spot + '"]');

						if(previousRow.find('.standing-order-spot').length == 1) {
							window.alert('Cannot move the last cell in the row');
						} else {
							if(previousSpot.length) previousSpot.remove();
							$(e.target).closest('.standing-order-spot').before(div);
						}
					}
					$('.standing-order-spot').removeClass('dragging-spot');
				} else {
					tileDrop($(e.target));
				}

				saveAllTableLayouts();
			}
		}, '[draggable="true"]');

		function spotDragStart(e) {
			$(e.target).addClass('dragging-spot');			

			//Write to setData
			e.originalEvent.dataTransfer.setData('type', 'spot');
			e.originalEvent.dataTransfer.setData('div', $(e.target).prop('outerHTML'));
			e.originalEvent.dataTransfer.setData('row', $(e.target).closest('.standing-order-row').attr('row'));
			e.originalEvent.dataTransfer.setData('spot', $(e.target).closest('.standing-order-spot').attr('spot'));
		}

		function tileDragStart(e, click = false) {
			const tile = $(e.target).closest('.co-tile');
			const tileParent = tile.parent();
			tileParent.addClass('dragging-from');

			//Write to setData
			activeDragItem.type = 'tile';
			activeDragItem.div = tile.prop('outerHTML');
			activeDragItem.part = tile.attr('part');
			activeDragItem.member_id = tile.attr('member_id');
			activeDragItem.availability_status = tile.attr('availability_status');

			console.log(activeDragItem);

			//Add .dragging for css
			tile.addClass('dragging');		

			//Add to selected div
			if(click) {
				console.log('clicked title');

				const selectedTileDiv = $('#selected-tile-' + tile.closest('.layout-number').attr('layout'));

				const selectedTileClass = tileParent.hasClass('standing-order-spot') ? 'is-standing-order' : 'is-status';
				const selectedTileParent = selectedTileDiv.closest('.selected-tile-wrapper');
				console.log(selectedTileDiv)
				console.log(selectedTileClass)
				console.log(selectedTileParent)
				if(selectedTileParent.hasClass(selectedTileClass)) {
					console.log('occupied')
					$('.click-selected').removeClass('click-selected');
					selectedTileDiv.html('');
					selectedTileParent.removeClass(selectedTileClass);
				}
				tile.addClass('click-selected');
				selectedTileDiv.html(activeDragItem.div);
				selectedTileParent.addClass(selectedTileClass);
			}
		}

		function tileDrop(target) {
			var div = activeDragItem.div;
			var part = activeDragItem.part;
			var memberId = activeDragItem.member_id;
			var availabilityStatus = activeDragItem.availability_status;

			console.log(activeDragItem);
			activeDragItem = {};

			const layoutNumber = target.closest('.layout-number').attr('layout');
			console.log(layoutNumber)

			var moved = true;
			var switched = false;
			if(target.closest('.standing-order-spot').length) {
				console.log('From .standing-order-spot');
				console.log(target);
				console.log(target.hasClass('standing-order-spot'));
				console.log(target.closest('standing-order-spot').hasClass('full'));
				if(!target.closest('.standing-order-spot').hasClass('full')) {
					target.append(div).addClass('full');
				} else if(target.closest('.standing-order-spot').hasClass('full')) {
					$('.dragging-from').each(function(){
						if($(this).hasClass('standing-order-spot') && $(this).hasClass('full')) draggedFromSpot = true;
					});
					if(draggedFromSpot) {
						var targetTile = target.closest('.standing-order-spot').html();
						var draggingFromSpot = $('.dragging-from')[0];
						$(draggingFromSpot).html(targetTile);
						console.log($('.dragging-from')[0]);
						target.closest('.standing-order-spot').html(div).addClass('full');
						switched = true;
					} else {
						console.log('cell full');
						moved = false;
					}
				}
			} else {
				console.log('Not from standing-order-spot');
				var draggedFromSpot = false
				$('.dragging-from').each(function(){
					if($(this).hasClass('standing-order-spot') && $(this).hasClass('full')) draggedFromSpot = true;
				});
				if(draggedFromSpot) {
					returnTile(div, part, availabilityStatus);
				} else {
					moved = false;
				}
			}

			if(moved) {
				if(switched) {
				} else {
					$('.dragging-from').removeClass('full');
					$('.dragging-from [member_id="' + memberId + '"]').remove();
				}
				$('.dragging-from').each(function(){
					$(this).removeClass('dragging-from');
				});
			}

			resetTable($('#selected-tile-' + layoutNumber))
		}

		$('.selected-tile-wrapper .selected-tile-actions .svg-wrapper.delete').on('click', function(){
			console.log('triggered delete button')
			$('.dragging-from').each(function(){
				$(this).removeClass('dragging-from');
			});
			resetTable($(this).closest('.selected-tile-wrapper').find('.selected-tile-content'));
		});

		$('.selected-tile-wrapper .selected-tile-actions .svg-wrapper.remove_user').on('click', function(){
			var div = activeDragItem.div;
			var part = activeDragItem.part;
			var memberId = activeDragItem.member_id;
			var availabilityStatus = activeDragItem.availability_status;

			$('.dragging-from').removeClass('full');
			$('.dragging-from [member_id="' + memberId + '"]').remove();

			returnTile(div, part, availabilityStatus);
			$('.dragging-from').each(function(){
				$(this).removeClass('dragging-from');
			});
			resetTable($(this).closest('.selected-tile-wrapper').find('.selected-tile-content'));
		});

		function resetTable(selectedTileDiv, moved, switched) {
			$('.dragging').removeClass('dragging');
			$('.click-selected').removeClass('click-selected');

			$('.selected-tile-wrapper').removeClass(['is-standing-order', 'is-status']);

			activeDragItem = {};

			selectedTileDiv.html('');
		}

		function returnTile(div, part, availabilityStatus) {
			var target = $('.co-tile-wrapper.standing-order-responses .part[part="' + part + '"] .status[status="' + availabilityStatus + '"]');
			target.append(div);

			sortToColumn(target);
		}

		function sortToColumn(column) {
			columnItems = [];
			column.find('.co-tile').each(function(){
				columnItems.push({
					first_name: $(this).attr('first_name'),
					last_name: $(this).attr('last_name'),
					el: $(this)
				});
				$(this).remove();
			});

			columnItems.sort(sortByName);
			$.each(columnItems, function(index, value){
				column.append(value.el);
			});
		}

		function sortByName(a, b) {
			let keys = [
				'last_name',
				'first_name'
			];

			let returnValue = 0;
			$.each(keys, function(index, value){
				returnValue = compareValues(a, b, value);
				if(returnValue != 0) return false;
			});
			return returnValue;		
		}

		function compareValues(a, b, key) {
			if(a[key] < b[key]) return -1;
			if(a[key] > b[key]) return 1;
			return 0;		
		}


		//=====================
		// Row Controls
		//=====================
		$('.standing-order-table').on('click', '.standing-order-row .row-controls .controls-wrapper .svg-wrapper', function(){
			const controlsDiv = $(this).closest('.standing-order-row');
			const parentDiv = $(this).closest('.standing-order-row-wrapper');
			const standingRowDivId = controlsDiv.attr('standing-row-target');
			const standingRowDiv = $('#' + standingRowDivId);

			let count = standingRowDiv.find('.standing-order-spot').length;
			let shift = parseInt(standingRowDiv.attr('shift'));

			if($(this).hasClass('plus')) {
				count++;
				standingRowDiv.attr('count', count).append('<div class="standing-order-spot" draggable="true"></div>');
				parentDiv.find('.row-controls .row-stats .count-value .total').html(count);
			} else if($(this).hasClass('minus')) {
				count--;
				if(count > 0) {
					const lastSpot = standingRowDiv.attr('count', count).find('.standing-order-spot:last-child');
					if(lastSpot.hasClass('full')) {
						const tile = lastSpot.find('.co-tile');
						returnTile(tile.prop('outerHTML'), tile.attr('part'), tile.attr('availability_status'));
					}
					lastSpot.remove();
					parentDiv.find('.row-controls .row-stats .count-value .total').html(count);
				}
			} else if($(this).hasClass('single-left')) {
				shift--;
				standingRowDiv.attr('shift', shift);
				parentDiv.find('.row-controls .row-stats .shift-value').html(shift / 2);
			} else if($(this).hasClass('single-right')) {
				shift++;
				standingRowDiv.attr('shift', shift);
				parentDiv.find('.row-controls .row-stats .shift-value').html(shift / 2);
			} else if($(this).hasClass('delete') || $(this).hasClass('remove_row')) {
				if(!standingRowDiv.hasClass('director')) {
					if(confirm('Are you sure you want to delete this row?')) {
						const parentTable = standingRowDiv.closest('.standing-order-table');
						standingRowDiv.find('.co-tile').each(function(){
							returnTile($(this).prop('outerHTML'), $(this).attr('part'), $(this).attr('availability_status'));
						});
						standingRowDiv.remove();
						parentDiv.remove();
						reorderRows(parentTable);
						reorderControlRows(parentTable.closest('.standing-order-table-wrapper'));
					}
				} else {
					if(confirm('Are you sure you want to delete this row?')) {
						standingRowDiv.find('.co-tile').each(function(){
							returnTile($(this).prop('outerHTML'), $(this).attr('part'), $(this).attr('availability_status'));
							$(this).remove();
						});
						standingRowDiv.find('.standing-order-spot').removeClass('full');
						$(this).closest('.standing-order-table').removeClass('has-director');
						standingRowDiv.closest('.standing-order-table').removeClass('has-director');
					}
				}
			}

			updateTablePadding();

			saveAllTableLayouts();
		});

		$('.standing-order-table .add-row').on('click', function(){
			console.log($(this).attr('class'));

			var parentDiv = $(this).closest('.standing-order-table');
			var rowsParentDiv = $('#standing-order-table-' + $(this).closest('.standing-order-table').attr('table'));
			var rowsDiv = $('#standing-order-rows-' + $(this).closest('.standing-order-table').attr('table'));
			var rowControlsDiv = $('#standing-order-row-controls-' + $(this).closest('.standing-order-table').attr('table'));
			const defaultCopiedDiv = $('#sample-standing-order-row').html(); 
			const defaultCopiedControlsDiv = $('#sample-standing-order-row-controls').html(); 

			let copiedDiv;
			let copiedDivSelector;
			if($(this).hasClass('above')) {
				//Standing Row
				copiedDivSelector = '.standing-order-row:first-of-type';
				copiedDiv = rowsDiv.find(copiedDivSelector).length ? getRowToCopy(rowsDiv, copiedDivSelector) : defaultCopiedDiv;
				rowsDiv.prepend(copiedDiv);

				//Controls Row
				copiedDivSelector = '.standing-order-row-wrapper:first-of-type';
				copiedDiv = rowControlsDiv.find(copiedDivSelector).length ? getRowToCopy(rowControlsDiv, copiedDivSelector) : defaultCopiedControlsDiv;
				rowControlsDiv.prepend(copiedDiv);
			} else if($(this).hasClass('below')) {
				//Standing Row
				copiedDivSelector = '.standing-order-row:last-of-type';
				copiedDiv = rowsDiv.find(copiedDivSelector).length ? getRowToCopy(rowsDiv, copiedDivSelector) : defaultCopiedDiv;
				rowsDiv.append(copiedDiv);

				//Controls Row
				copiedDivSelector = '.standing-order-row-wrapper:last-of-type';
				copiedDiv = rowControlsDiv.find(copiedDivSelector).length ? getRowToCopy(rowControlsDiv, copiedDivSelector) : defaultCopiedControlsDiv;
				rowControlsDiv.append(copiedDiv);
			} else if($(this).hasClass('director')) {
				parentDiv.addClass('has-director');
				rowsParentDiv.addClass('has-director');
			}

			reorderRows($(this).closest('.standing-order-table-wrapper'));
			reorderControlRows($(this).closest('.standing-order-table-wrapper'));

			saveAllTableLayouts();
		});

		function reorderRows(table) {
			var rows = table.find('.standing-order-rows.view .standing-order-row');
			var i = rows.length;
			rows.each(function(){
				const previousRowNumber = $(this).attr('row');
				const previousRowId = $(this).attr('id');
				const newRowId = previousRowId.replace('__row_' + previousRowNumber, '__row_' + i);
				$(this).attr('row', i);
				$(this).attr('id', newRowId);
				i--;
			});
		}

		function reorderControlRows(table) {
			var rows = table.find('.standing-order-table.has-controls .standing-order-row-wrapper');
			var i = rows.length;
			rows.each(function(){
				const controls = $(this).find('.standing-order-row.has-controls');
				const previousRowNumber = $(controls[0]).attr('row');
				const previousRowId = $(controls[0]).attr('standing-row-target');
				const newRowId = previousRowId.replace('__row_' + previousRowNumber, '__row_' + i);
				controls.each(function(){
					$(this).attr('row', i);
					$(this).attr('standing-row-target', newRowId);
				});
				i--;
			});
		}

		function getRowToCopy(rowsDiv, selector) {
			var copiedDiv = rowsDiv.find(selector).prop('outerHTML');
			var copiedDivObj = $(copiedDiv)
			copiedDivObj.find('.co-tile').each(function(){
				$(this).closest('.standing-order-spot').removeClass('full');
				$(this).remove();
			});
			return copiedDivObj.prop('outerHTML');
		}

		function updateTablePadding() {
			var largestCount = 0;
			var furthestLeft = 0;
			var furthestRight = 0;

			$('.standing-order-table .standing-order-rows.view .standing-order-row').each(function(){
				var count = parseInt($(this).attr('count'));
				var shift = parseInt($(this).attr('shift'));

				if(count > largestCount) largestCount = count;

				leftX = count + Math.abs(shift);
				rightX = count + shift;

				if(leftX > furthestLeft && shift < 0) furthestLeft = leftX;
				if(rightX > furthestRight && shift > 0) furthestRight = rightX;
			});

			$('.standing-order-table').attr('left_shift', furthestLeft == 0 ? 0 : furthestLeft - largestCount).attr('right_shift', furthestRight == 0 ? 0 : furthestRight - largestCount);
		}
	}

	$('.standing-order-responses .part .svg-wrapper').on('click', function(){
		if($(this).closest('.status').length) {
			$(this).closest('.status').toggleClass('collapsed');
		} else {
			$(this).closest('.part').toggleClass('collapsed');
		}
	});

	$('.standing-order-table.has-controls .expand-collapse-button').on('click', function(){
		$(this).closest('.standing-order-table-wrapper.has-edit-controls').toggleClass('show-edit-controls');
	});

	if($('#standing-order-to-copy').length) {
		$(document).on('co_load_standing_order', '.field.typeahead', function(event, vars){
			const parentDiv = $(this);
			const fieldName = parentDiv.find('.settings').attr('fieldName');
			const settings = JSON.parse(atob(parentDiv.find('.settings').attr('settings')));
			const postId = vars.result.attr('post_id');

			console.log(postId);
			console.log(vars);
			console.log(settings);
			console.log(fieldName);

			let data = {
				action: 'choralorg_standing-order_load_order_from_id',
				post_id: postId,
			};
			$.post('/wp-admin/admin-ajax.php', data, function(response){
				$('#standing-order-to-copy').html(response).closest('.child-menu-footer-item.standing-order').addClass('selected');
				$('#apply-standing-order-button').attr('post_id', postId);
			});
		});

		$('#apply-standing-order-button').on('click', function(e){
			e.preventDefault();

			const postId = $(this).attr('post_id');
			console.log(postId);

			saveAllPreviousTableLayouts();

			let data = {
				action: 'choralorg_standing-order_apply_typeahead_order',
				post_id: postId,
			};
			$('#standing-order-to-copy').html('<h3 style="text-align: center; color: white;">Applying...</h3>').closest('.child-menu-footer-item.standing-order');
			$.post('/wp-admin/admin-ajax.php', data, function(response){
				$('#standing-order-wrapper').html(response);
				setTimeout(function(){
					saveAllTableLayouts();
					setTimeout(function(){
						$('#standing-order-to-copy').html('<h3 style="text-align: center; color: white;">Refreshing...</h3>')
						window.location.reload();
					}, 500);
				}, 100);
			});

		});

		$('#cancel-standing-order-button').on('click', function(e){
			e.preventDefault();
	
			$('#apply-standing-order-button').attr('post_id', '');
			$('#standing-order-to-copy').html('').closest('.child-menu-footer-item.standing-order').removeClass('selected');
		});
	}





	if($('#print-standing-order').length) {
		document.getElementById('print-standing-order').onclick = function() {
			const rowWidth = $('#standing-order-table-0').width();
			const rowHeight = $('#standing-order-layout-0').height();

			const windowWidthInches = rowWidth / 96;
			const windowHeightInches = windowWidthInches * 8.5 / 11;

			const landscapeDimensions = 11 * 96;
			const fitToPageScale = landscapeDimensions / rowWidth;

			const margin = .5;

			const element = $('html');
			const options = {
				margin: margin,
				image: {
					type: 'jpeg',
					quality: 1,
				},
				html2canvas: {
					scale: 2,

					width: rowWidth,
					height: rowHeight,
				},
				jsPDF: {
					unit: 'in',
					format: [
						windowHeightInches + (margin * 2),
						windowWidthInches + (margin * 2)
					],
					orientation: 'landscape',
				},
			};

			console.log(options);

			html2pdf().set(options).from(element[0]).save();
		};
	}

});
